import omit from 'lodash/omit';
import React, { memo } from 'react';
import { Input } from '../Input';
import { type NumberFieldProps } from './NumberField.types';

const NumberField: React.FC<NumberFieldProps> = memo((props) => {
  const { dataTestId = 'number-field' } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Convert empty input to a 0.
    let value = 0;
    if (event.target.value) {
      value = Number(event.target.value);
    }
    props.onChangeValue?.(value);

    if ('changeByProp' in props) {
      props.onChange?.(props.changeByProp, value);
    } else {
      props.onChange?.({ value });
    }
  };

  const inputProps = omit(props, ['onChangeValue', 'onChange', 'changeByProp']);
  inputProps.min = props.min ?? 0;
  inputProps.step = props.step ?? 1;
  inputProps.disabled = props.disabled ?? false;
  inputProps.autoFocus = props.autoFocus ?? false;

  return (
    // eslint-disable-next-line
    // @ts-ignore
    <Input
      {...inputProps}
      type="number"
      className={`number-field ${props.className || ''}`}
      onChange={handleChange}
      ref={props.refFunc}
      data-testid={dataTestId}
    />
  );
});

// Display Name
NumberField.displayName = 'NumberField';

export default NumberField;
